export default __webpack_public_path__ + "static/media/nutri-highlight.f8d5833f.svg";